import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, FormLabel, Radio, RadioGroup, Typography } from '@mui/material';
import { listKeyValueStatus } from 'shared/types';

interface IValidaModal {
  open: boolean;
  title: string;
  message:string;
  onClose: () => void;
  onConfirm: () => void;
}

export const ConfirmacaoModal: React.FC<IValidaModal> = ({
  open,
  title,
  message,
  onClose,
  onConfirm
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="draggable-dialog-title"
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Typography>
          {message}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button
          color='primary'
          variant='contained'
          onClick={onClose}
        >
          Cancelar
        </Button>
        <Button
          color='primary'
          variant='contained'
          onClick={onConfirm}
        >
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};